import { Component, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { FileSelectionListBaseComponent } from '@app/shared/components/file-upload/file-selection-list-base.component';

@Component({
  selector: 'file-selection-list',
  templateUrl: './file-selection-list.component.html',
  styleUrls: ['./file-selection-list.component.scss']
})
export class FileSelectionListComponent extends FileSelectionListBaseComponent implements OnInit {

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
  }

  public ngOnInit() {
  }

}
